import React from "react";
import styled from "styled-components";
import JsxSyntaxHighlighter from "../../ui/JsxSyntaxHighlighter";
import ApiLink from "../../ui/ApiLink";

export default function DefaultConfig() {
  return (
    <Styles>
      <JsxSyntaxHighlighter>
        {`defaultConfig: Readonly<MinibeakConfig>`}
      </JsxSyntaxHighlighter>

      <p>
        A frozen starting point for request configuration. Spread it into the
        config of every <ApiLink name="useProFile" /> and{" "}
        <ApiLink name="callProFile" /> call. Minibeak never applies it
        implicitly, so a call without <code>apiUrl</code> fails.
      </p>

      <p>
        To change the defaults for your application, build your own frozen
        config object from it and spread that one instead:
      </p>

      <JsxSyntaxHighlighter>
        {`import { defaultConfig, useProFile } from "@dossier/minibeak";

export const appConfig = Object.freeze({
  ...defaultConfig,
  apiUrl: "http://localhost:8080/profile/jsonapi",
  throwErrors: true,
});

const orgUnits = useProFile({ ...appConfig, path: "/orgUnits" });
`}
      </JsxSyntaxHighlighter>

      <p>
        Implements <ApiLink name="MinibeakConfig" />.
      </p>
    </Styles>
  );
}

const Styles = styled.div``;
